import { useRef, useLayoutEffect } from "react"
import PropTypes from "prop-types"
import { fitFontSize, lineHeightRatioOf } from "../scripts/fit_text"

const Fittty = ({ minSize, maxSize, mode, text }) => {
  const innerRef = useRef(null)

  useLayoutEffect(() => {
    const innerEl = innerRef.current
    if (!innerEl || !text) return

    const containerEl = innerEl.parentElement
    if (!containerEl) return

    const computed = getComputedStyle(innerEl)

    const fontSize = fitFontSize({
      text,
      fontFamily: computed.fontFamily,
      fontWeight: computed.fontWeight,
      containerWidth: containerEl.clientWidth,
      containerHeight: containerEl.clientHeight,
      minFs: minSize,
      maxFs: maxSize,
      lineHeightRatio: lineHeightRatioOf(computed),
      mode,
    })

    innerEl.style.fontSize = `${fontSize}px`
  }, [text, minSize, maxSize, mode])

  return <span ref={innerRef}>{text}</span>
}

Fittty.propTypes = {
  text: PropTypes.string.isRequired,
  minSize: PropTypes.number,
  maxSize: PropTypes.number,
  mode: PropTypes.string,
}

Fittty.defaultProps = {
  minSize: 20,
  maxSize: 52,
  mode: "oneline",
}

export default Fittty
